// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RunStatistics
 */
export interface RunStatistics {
    /**
     * 
     * @type {number}
     * @memberof RunStatistics
     */
    recordsDeduplicated: number;
    /**
     * 
     * @type {number}
     * @memberof RunStatistics
     */
    recordsInserted: number;
    /**
     * 
     * @type {number}
     * @memberof RunStatistics
     */
    recordsProcessed: number;
    /**
     * 
     * @type {number}
     * @memberof RunStatistics
     */
    recordsQuarantined: number;
    /**
     * 
     * @type {number}
     * @memberof RunStatistics
     */
    recordsUnchanged: number;
    /**
     * 
     * @type {number}
     * @memberof RunStatistics
     */
    recordsUpdated: number;
}

/**
 * Check if a given object implements the RunStatistics interface.
 */
export function instanceOfRunStatistics(value: object): value is RunStatistics {
    if (!('recordsDeduplicated' in value) || value['recordsDeduplicated'] === undefined) return false;
    if (!('recordsInserted' in value) || value['recordsInserted'] === undefined) return false;
    if (!('recordsProcessed' in value) || value['recordsProcessed'] === undefined) return false;
    if (!('recordsQuarantined' in value) || value['recordsQuarantined'] === undefined) return false;
    if (!('recordsUnchanged' in value) || value['recordsUnchanged'] === undefined) return false;
    if (!('recordsUpdated' in value) || value['recordsUpdated'] === undefined) return false;
    return true;
}

export function RunStatisticsFromJSON(json: any): RunStatistics {
    return RunStatisticsFromJSONTyped(json, false);
}

export function RunStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunStatistics {
    if (json == null) {
        return json;
    }
    return {
        
        'recordsDeduplicated': json['recordsDeduplicated'],
        'recordsInserted': json['recordsInserted'],
        'recordsProcessed': json['recordsProcessed'],
        'recordsQuarantined': json['recordsQuarantined'],
        'recordsUnchanged': json['recordsUnchanged'],
        'recordsUpdated': json['recordsUpdated'],
    };
}

export function RunStatisticsToJSON(json: any): RunStatistics {
    return RunStatisticsToJSONTyped(json, false);
}

export function RunStatisticsToJSONTyped(value?: RunStatistics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'recordsDeduplicated': value['recordsDeduplicated'],
        'recordsInserted': value['recordsInserted'],
        'recordsProcessed': value['recordsProcessed'],
        'recordsQuarantined': value['recordsQuarantined'],
        'recordsUnchanged': value['recordsUnchanged'],
        'recordsUpdated': value['recordsUpdated'],
    };
}
